<mat-card>
  <button
    gaEvent="add_product"
    data-test="addStoreProduct"
    (click)="openDialog()"
    mat-icon-button
    color="accent"
  >
    <mat-icon>add</mat-icon>
  </button>
</mat-card>
